module.exports = __webpack_public_path__ + "img/30_13.89b82dab.png";